import LoadingScreen from "../../core/components/LoadingScreen";

const AzureAuth = () => {
  return <LoadingScreen/>;
};

export default AzureAuth;